import { defineMessages } from 'react-intl'

const scope = `procurify.components.Budgets.BudgetCategoryForm`

export default defineMessages({
  createModalTitle: {
    id: `${scope}.createModalTitle`,
    defaultMessage: 'Create Budget',
  },
  editModalTitle: {
    id: `${scope}.editModalTitle`,
    defaultMessage: 'Edit Budget',
  },
  nameFieldRequiredError: {
    id: `${scope}.nameFieldRequiredError`,
    defaultMessage: 'Name field is required',
  },
  nameFieldPlaceholder: {
    id: `${scope}.nameFieldPlaceholder`,
    defaultMessage: 'Name this budget',
  },
  nameFieldLabel: {
    id: `${scope}.nameFieldLabel`,
    defaultMessage: 'Name',
  },
  budgetCategoryAttributesInstructionText: {
    id: `${scope}.budgetCategoryAttributesInstructionText`,
    defaultMessage: `Track spend with the following: (select at least one {asterisk})`,
  },
  departmentsFieldPlaceholder: {
    id: `${scope}.departmentsFieldPlaceholder`,
    defaultMessage: 'Select an option',
  },
  departmentsFieldLabel: {
    id: `${scope}.departmentsFieldLabel`,
    defaultMessage: '{pluralSecondaryOrgCategoryLabel}',
  },
  accountCodesFieldPlaceholder: {
    id: `${scope}.accountCodesFieldPlaceholder`,
    defaultMessage: 'Select an option',
  },
  accountCodesFieldLabel: {
    id: `${scope}.accountCodesFieldLabel`,
    defaultMessage: 'Account codes',
  },
  departmentOrAccountCodeFieldsRequiredError: {
    id: `${scope}.departmentOrAccountCodeFieldsRequiredError`,
    defaultMessage:
      'Select at least one value in either the {singularSecondaryOrgCategoryLabel} or Account Code fields',
  },
  usersViewAccessRequiredError: {
    id: `${scope}.usersViewAccessRequiredError`,
    defaultMessage: 'User View Access selections are required',
  },
  usersViewAccessFieldPlaceholder: {
    id: `${scope}.usersViewAccessFieldPlaceholder`,
    defaultMessage: 'Select users',
  },
  usersViewAccessFieldLabel: {
    id: `${scope}.usersViewAccessFieldLabel`,
    defaultMessage: 'Give viewing access to',
  },
  isSourceOfTruthLabel: {
    id: `${scope}.isSourceOfTruthLabel`,
    defaultMessage: 'This budget is a source of truth',
  },
  budgetFieldRequiredError: {
    id: `${scope}.budgetFieldRequiredError`,
    defaultMessage: 'A budget value is required',
  },
  budgetFieldGreaterThanZeroError: {
    id: `${scope}.budgetFieldGreaterThanZeroError`,
    defaultMessage: 'Budget value must be greater than 0',
  },
  budgetFieldPlaceholder: {
    id: `${scope}.budgetFieldPlaceholder`,
    defaultMessage: '0.00',
  },
  budgetFieldLabel: {
    id: `${scope}.budgetFieldLabel`,
    defaultMessage: 'Budget',
  },
  startDateRequiredError: {
    id: `${scope}.startDateRequiredError`,
    defaultMessage: 'Budget start date is required',
  },
  endDateRequiredError: {
    id: `${scope}.endDateRequiredError`,
    defaultMessage: 'Budget end date is required',
  },
  submitCreateButton: {
    id: `${scope}.submitCreateButton`,
    defaultMessage: 'Create',
  },
  submitEditButton: {
    id: `${scope}.submitEditButton`,
    defaultMessage: 'Save changes',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  budgetsHeader: {
    id: `${scope}.budgetsHeader`,
    defaultMessage: 'Date Ranges and Budgets',
  },
  setBudgetFieldsForDateRangesLabel: {
    id: `${scope}.setBudgetFieldsForDateRangesLabel`,
    defaultMessage: 'Set a budget for each date range',
  },
  budgetPeriodFieldLabel: {
    id: `${scope}.budgetPeriodFieldLabel`,
    defaultMessage: 'Set a budget for',
  },
  budgetPeriodRequiredError: {
    id: `${scope}.budgetPeriodRequiredError`,
    defaultMessage: 'A budget period value is required',
  },
  customBudgetCheckboxLabel: {
    id: `${scope}.customBudgetCheckboxLabel`,
    defaultMessage: 'Customize budget for each period',
  },
  newDateRangeTitle: {
    id: `${scope}.newDateRangeTitle`,
    defaultMessage: 'New Date Range',
  },
  addDateRangeTitle: {
    id: `${scope}.addDateRangeTitle`,
    defaultMessage: 'Add date range',
  },
  dateRangeLabel: {
    id: `${scope}.dateRangeLabel`,
    defaultMessage: 'Date range',
  },
  deleteDateRangeButton: {
    id: `${scope}.deleteDateRangeButton`,
    defaultMessage: 'Delete date range',
  },
  dateRangeTooLargeErrorTitle: {
    id: `${scope}.dateRangeTooLargeErrorTitle`,
    defaultMessage: 'This date range is too large',
  },
  dateRangeTooLargeErrorMsg: {
    id: `${scope}.dateRangeTooLargeErrorMsg`,
    defaultMessage:
      'Only date ranges of up to 5 years (60 months) can be set up',
  },
  dateRangeOverlapErrorTitle: {
    id: `${scope}.dateRangeOverlapErrorTitle`,
    defaultMessage: 'This date range overlaps an existing date range',
  },
  dateRangeOverlapErrorMsg: {
    id: `${scope}.dateRangeOverlapErrorMsg`,
    defaultMessage:
      'Date ranges must not overlap. Either adjust the dates or create a new budget to track this spend.',
  },
  dateRangePartialCoverageWarningTitle: {
    id: `${scope}.dateRangePartialCoverageWarningTitle`,
    defaultMessage: 'This date range creates a partial period',
  },
  dateRangePartialCoverageWarningMsg: {
    id: `${scope}.dateRangePartialCoverageWarningMsg`,
    defaultMessage:
      'The specified date range starts and/or ends partway through a specified period. You can continue, but your budget for the partial period(s) will remain the same as the complete periods.',
  },
})
